import *  as API from "@/api/api"

export default {
    // 菜单权限
    API: {
        System: {
            module: {
                user: {
                    apiList: {
                        list: { name: "查看", API: false, key: "System.user.list" },
                        add: { name: "添加", API: API.SYSTEM.USER.ADD, key: "System.user.add" },
                        edit: { name: "修改", API: API.SYSTEM.USER.EDIT, key: "System.user.edit" },
                        enable: { name: "启用、禁用", API: API.SYSTEM.USER.ENABLE, key: "System.user.enable" },
                        reset: { name: "重置密码", API: API.SYSTEM.USER.REFRESH_PSW, key: "System.user.reset" },
                        del: { name: "删除", API: API.SYSTEM.USER.DEL_USER, key: "System.user.del" },
                        export: { name: "导出excel", API: false, key: "System.user.export" }
                    },
                    value: "user",
                    name: "账号分配",
                    key: "System.user.list"
                },
                role: {
                    name: "角色管理",
                    value: "role",
                    key: "System.role.list",
                    apiList: {
                        list: { name: "查看", API: false, key: "System.role.list" },
                        add: { name: "添加", API: API.SYSTEM.ROLE.ADD, key: "System.role.add" },
                        edit: { name: "修改", API: API.SYSTEM.ROLE.EDIT, key: "System.role.edit" },
                        enable: { name: "启用、禁用", API: API.SYSTEM.USER.ENABLE, key: "System.role.enable" },
                        del: { name: "删除", API: API.SYSTEM.USER.DEL_USER, key: "System.role.del" },
                        export: { name: "导出excel", API: false, key: "System.role.export" }
                    }
                },
                log: {
                    name: "查看日志",
                    value: "log",
                }
            },
            $menu: "System"
        },
        salesman: {
            module: {
                business: {
                    apiList: {
                        list: { name: "查看", API: false, key: "salesman.business.list" },
                        add: { name: "添加", API: API.SALESMAN.BUSINESS.ADD, key: "salesman.business.add" },
                        edit: { name: "修改", API: API.SALESMAN.BUSINESS.EDIT, key: "salesman.business.edit" },
                        details: { name: "修改", API: API.SALESMAN.BUSINESS.DETAILS, key: "salesman.business.details" },
                        del: { name: "删除", API: API.SALESMAN.BUSINESS.DEL, key: "salesman.business.del" },
                        enable: { name: "启用、禁用", API: API.SALESMAN.BUSINESS.ENABLE, key: "salesman.business.enable" },
                        order: { name: "订单", API: false, key: "salesman.business.order" },
                        customer: { name: "客户", API: false, key: "salesman.business.customer" },
                        // reset: { name: "重置密码", API: API.SYSTEM.USER.REFRESH_PSW, key: "System.user.reset" },
                        // export: { name: "导出excel", API: false, key: "salesman.business.export" }
                    },
                    value: "business",
                    name: "业务",
                    key: "salesman.business.list"
                },
            },
            $menu: "salesman"
        },
        customers: {
            module: {
                ment: {
                    apiList: {
                        list: { name: "查看", API: false, key: "customers.ment.list" },
                        add: { name: "添加", API: API.COSTOMENT.MENT.ADD, key: "customers.ment.add" },
                        region: { name: "转移区", API: API.COSTOMENT.MENT.TRANSFERREGION, key: "customers.ment.region" },
                        whole: { name: "转移全部", API: API.COSTOMENT.MENT.TRANSFERWHOLE, key: "customers.ment.whole" },
                        edit: { name: "修改", API: API.COSTOMENT.MENT.EDIT, key: "customers.ment.edit" },
                        ears: { name: "欠款", API: API.COSTOMENT.MENT.EARS, key: "customers.ment.ears" },
                        details: { name: "修改", API: API.COSTOMENT.MENT.DETAILS, key: "customers.ment.details" },
                        del: { name: "删除", API: API.COSTOMENT.MENT.DEL, key: "customers.ment.del" },
                        // export: { name: "导出excel", API: false, key: "customers.ment.export" }
                    },
                    value: "ment",
                    name: "客户",
                    key: "customers.ment.list"
                },
            },
            $menu: "customers"
        },
        ware: {
            module: {
                warehouse: {
                    apiList: {
                        list: { name: "查看", API: false, key: "ware.warehouse.list" },
                        add: { name: "添加", API: API.WARE.WAREHOUSE.ADD, key: "ware.warehouse.add" },
                        edit: { name: "修改", API: API.WARE.WAREHOUSE.EDIT, key: "ware.warehouse.edit" },
                        details: { name: "详细", API: API.WARE.WAREHOUSE.DETAILS, key: "ware.warehouse.details" },
                        del: { name: "删除", API: API.WARE.WAREHOUSE.DEL, key: "ware.warehouse.del" },
                        // export: { name: "导出excel", API: false, key: "ware.warehouse.export" }
                    },
                    value: "warehouse",
                    name: "仓库管理",
                    key: "ware.warehouse.list"
                },
                goods: {
                    apiList: {
                        list: { name: "查看", API: false, key: "ware.goods.list" },
                        add: { name: "添加", API: API.WARE.GOODS.ADD, key: "ware.goods.add" },
                        edit: { name: "修改", API: API.WARE.GOODS.EDIT, key: "ware.goods.edit" },
                        details: { name: "详情", API: API.WARE.GOODS.DETAILS, key: "ware.goods.details" },
                        del: { name: "删除", API: API.WARE.GOODS.DEL, key: "ware.goods.del" },
                        inware: { name: "入库", API: false, key: "ware.goods.inware" }
                    },
                    value: "goods",
                    name: "商品管理",
                    key: "ware.goods.list"
                },
                commodity: {
                    apiList: {
                        list: { name: "查看", API: false, key: "ware.commodity.list" },
                        ears: { name: "欠款", API: API.WARE.COMMODITY.EARS, key: "ware.commodity.ears" },
                        details: { name: "详情", API: API.WARE.COMMODITY.DETAILS, key: "ware.commodity.details" },
                        del: { name: "删除", API: API.WARE.COMMODITY.DEL, key: "ware.commodity.del" },
                        change: { name: "换库", API: false, key: "ware.commodity.change" },
                        return:{ name: "退款", API: false, key: "ware.commodity.return" }
                    },
                    value: "commodity",
                    name: "商品库存管理",
                    key: "ware.commodity.list"
                },
                returnList: {
                    apiList: {
                        list: { name: "查看", API: false, key: "ware.returnList.list" },
                        edit: { name: "修改", API: API.WARE.RETURNLIST.EDIT, key: "ware.returnList.edit" },
                        cancel: { name: "取消", API: API.WARE.RETURNLIST.CANCEL, key: "ware.returnList.cancel" },
                    },
                    value: "returnList",
                    name: "退货单管理",
                    key: "ware.returnList.list"
                },
                changeList: {
                    apiList: {
                        list: { name: "查看", API: false, key: "ware.changeList.list" },
                        edit: { name: "修改", API: API.WARE.CHANGELIST.EDIT, key: "ware.changeList.edit" },
                        cancel: { name: "取消", API: API.WARE.CHANGELIST.CANCEL, key: "ware.changeList.cancel" },
                    },
                    value: "changeList",
                    name: "换货单管理",
                    key: "ware.changeList.list"
                },
            },
            $menu: "ware"
        },
        sale: {
            module: {
               order: {
                    apiList: {
                        list: { name: "查看", API: false, key: "sale.order.list" },
                        add: { name: "添加", API: API.SALE.ORDER.ADD, key: "sale.order.add" },
                        edit: { name: "修改", API: API.SALE.ORDER.EDIT, key: "sale.order.edit" },
                        cancel: { name: "取消", API: API.SALE.ORDER.CANCEL, key: "sale.order.cancel" },
                        details: { name: "详情", API: API.SALE.ORDER.DETAILS, key: "sale.order.details" },
                        del: { name: "删除", API: API.SALE.ORDER.DELGOOD, key: "sale.order.del" },
                        info: { name: "详情", API: API.SALE.ORDER.DELGOOD, key: "sale.order.info" },
                        addgood: { name: "添加销售单", API: API.SALE.ORDER.ADDGOOD, key: "sale.order.addgood" },
                        editgood: { name: "修改销售单", API: API.SALE.ORDER.UPDATEGOOD, key: "sale.order.editgood" },
                    },
                    value: "order",
                    name: "销售单管理",
                    key: "sale.order.list"
                },
                goodsInfo: {
                     apiList: {
                         list: { name: "查看", API: false, key: "sale.goodsInfo.list" },
                     },
                     value: "goodsInfo",
                     name: "销售单明细",
                     key: "sale.goodsInfo.list"
                 },
                returnOrder: {
                    apiList: {
                        list: { name: "查看", API: false, key: "sale.returnOrder.list" },
                        add: { name: "添加", API: API.SALE.RETURNORDER.ADD, key: "sale.returnOrder.add" },
                        edit: { name: "修改", API: API.SALE.RETURNORDER.EDIT, key: "sale.returnOrder.edit" },
                        can: { name: "取消", API: API.SALE.RETURNORDER.CANCEL, key: "sale.returnOrder.can" },
                        pay: { name: "支付", API: API.SALE.RETURNORDER.PAY, key: "sale.returnOrder.pay" },
                    },
                    value: "returnOrder",
                    name: "退货单管理",
                    key: "sale.returnOrder.list"
                },
                changeOrder: {
                    apiList: {
                        list: { name: "查看", API: false, key: "sale.changeOrder.list" },
                        add: { name: "添加", API: API.SALE.CHANGEORDER.ADD, key: "sale.changeOrder.add" },
                        edit: { name: "修改", API: API.SALE.CHANGEORDER.EDIT, key: "sale.changeOrder.edit" },
                    },
                    value: "changeOrder",
                    name: "换货单管理",
                    key: "sale.changeOrder.list"
                },
            },
            $menu: "sale"
        },
        purchase: {
            module: {
               orders: {
                    apiList: {
                        list: { name: "查看", API: false, key: "purchase.orders.list" },
                        addgood: { name: "添加采购单", API: API.PURCHASE.ORDERS.ADDGOOD, key: "purchase.orders.addgood" },
                        // edit: { name: "修改", API: API.PURCHASE.ORDERS.EDIT, key: "purchase.orders.edit" },


                        // editgood: { name: "修改销售单", API: API.PURCHASE.ORDERS.UPDATEGOOD, key: "purchase.orders.editgood" },

                        can: { name: "取消", API: API.PURCHASE.ORDERS.CANCEL, key: "purchase.orders.can" },
                        details: { name: "详情", API: API.PURCHASE.ORDERS.DETAILS, key: "purchase.orders.details" },
                    },
                    value: "orders",
                    name: "采购单管理",
                    key: "purchase.orders.list"
                },

            },
            $menu: "purchase"
        },
    },
    menu: {
        ware: { value: "ware", title: "仓库", icon: "icon-cangku", size: "font-size:24px", show: true },
        customers: { value: "customers", title: "客户", icon: "icon-kehu", size: "font-size:24px", show: true },
        salesman: { value: "salesman", title: "业务", icon: "icon-zu176", size: "font-size:24px", show: true },
        sale: { value: "sale", title: "销售", icon: "icon-xiaoshou", size: "font-size:22px", show: true },
        purchase: { value: "purchase", title: "采购", icon: "icon-tubiaozhizuomoban", size: "font-size:22px", show: true },
        System: { value: "System", title: "系统", icon: "icon-shezhi", size: "font-size:22px", show: true },

    },
}



// WEBPACK FOOTER //
// ./src/config/menu.js